import React from 'react';
import type { GradingAnswerSnapshot, GradingResultSnapshot } from '../../../Community/marketProfile/marketProfileStore';

type Props = {
  result: GradingResultSnapshot | null;
  answers: GradingAnswerSnapshot[];
};

export default function GradingAnswersReview({ result, answers }: Props) {
  return (
    <div className="space-y-4">
      {result && (
        <div className="grid gap-1 sm:grid-cols-2 rounded-md border border-slate-100 bg-slate-50 p-3 text-sm">
          <div><span className="text-slate-500">Семейство:</span> {result.familyName || '—'}</div>
          <div><span className="text-slate-500">Кластер:</span> {result.roleClusterName || '—'}</div>
          {result.specializationName && (
            <div><span className="text-slate-500">Специализация:</span> {result.specializationName}</div>
          )}
          <div><span className="text-slate-500">Роль:</span> {result.roleName || '—'}</div>
          <div><span className="text-slate-500">Уровень:</span> {result.gradeLevel ?? '—'}</div>
          <div><span className="text-slate-500">Суммарный балл:</span> {result.totalScore ?? '—'}</div>
        </div>
      )}

      {answers.length > 0 ? (
        <ol className="space-y-3">
          {answers.map((item, index) => (
            <li
              key={`${item.questionId}-${index}`}
              className="rounded-md border border-slate-200 p-3"
            >
              <div className="text-xs font-medium uppercase tracking-wide text-slate-500">
                {item.factorName}
              </div>
              <div className="mt-1 font-medium text-slate-900">{item.questionText}</div>
              <div className="mt-2 text-sm text-slate-700">{item.answerText || '—'}</div>
              <div className="mt-2 text-xs text-slate-500">Балл ответа: {item.answerScore}</div>
            </li>
          ))}
        </ol>
      ) : (
        <p className="text-sm text-slate-500">Ответы на вопросы грейдинга не сохранены.</p>
      )}
    </div>
  );
}
